import Blue from "~/core";

new Blue(
    {
        name: "ProgramSearchResults",
        selector: ".aviation-program-search",
        setup(programSearch) {

            const programSearchResultDisplayListButton = programSearch.querySelector(".aviation-career-search__button-list");
            const programSearchResultDisplayGridButton = programSearch.querySelector(".aviation-career-search__button-grid");
            const programSearchResetFormButton = programSearch.querySelector('button[type="reset"]');
            const programSearchList = programSearch.querySelector('.aviation-program-search__results');
            const programSearchFormTextInputs = programSearch.querySelectorAll(".aviation-program-search__input");
            const programSearchResultControls = programSearch.querySelector(".aviation-program-search__results-controls");
                
            programSearchResetFormButton.addEventListener('click', (e) => {
                e.preventDefault();
                resetProgramSearchForm();
            });

            programSearchResultDisplayListButton?.addEventListener('click', (e) => {
                toggleProgramSearchResultDisplayStyle(e);
            });
            
            programSearchResultDisplayGridButton?.addEventListener('click', (e) => {
                toggleProgramSearchResultDisplayStyle(e);
            });
    
            function toggleProgramSearchResultDisplayStyle(e) {
                programSearchResultDisplayListButton.classList.remove('active');
                programSearchResultDisplayGridButton.classList.remove('active');
                
                var currentTarget = e.currentTarget;

                currentTarget.classList.add('active')

                if (currentTarget == programSearchResultDisplayListButton) {
                    programSearchList.classList.remove('grid');
                }
                else {
                    programSearchList.classList.add('grid');
                }
            }
        
            function resetProgramSearchForm(){
                if(programSearchResultControls != null){
                    programSearchResultControls.style.display = "none";
                }

                if(programSearchList != null){
                    programSearchList.replaceChildren();
                }

                if(programSearchFormTextInputs != null){
                    programSearchFormTextInputs.forEach(element => {
                        element.value = "";
                    })
                }

                var cleanedUrl = window.location.href.replace(location.search, "");

                window.history.pushState("", "", cleanedUrl);
            }
        }
    }
)